// ============================================================
// מיפוי שדות לפי תקן מבנה אחיד 008 — חוזר רשות שוק ההון
// ============================================================

export const SUG_MUTZAR = {
  "1": "ביטוח חיים משולב חיסכון",
  "2": "קרן פנסיה",
  "3": "קופת גמל",
  "4": "קרן השתלמות",
  "5": "פוליסת חיסכון טהור",
  "6": "פוליסת סיכון טהור (ריסק)",
  "7": "ביטוח חיים משכנתא",
  "8": "פוליסת סיכון קולקטיב",
  "9": "קופת גמל להשקעה",
  "10": "חיסכון לכל ילד",
};

export const SUG_MUTZAR_CATEGORY = {
  "1": "ביטוח מנהלים",
  "2": "קרן פנסיה",
  "3": "קופת גמל",
  "4": "קרן השתלמות",
  "5": "ביטוח מנהלים",
  "6": "ביטוח חיים",
  "7": "ביטוח חיים",
  "8": "ביטוח חיים",
  "9": "קופת גמל להשקעה",
  "10": "חיסכון לכל ילד",
  // לא מתקן 008 — מוצר תיק מנוהל מבתי השקעות (ייבוא Excel)
  "תיק מנוהל": "תיק מנוהל",
};

export const SUG_MUTZAR_ICON = {
  "1": "🏛️", "2": "👴", "3": "💰", "4": "📚",
  "5": "🏛️", "6": "🛡️", "7": "🏠", "8": "🛡️",
  "9": "🚀", "10": "👶",
  "תיק מנוהל": "📈",
};

export const STATUS_POLISA = {
  "1": "פעיל",
  "2": "מוקפא / מסולק",
  "3": "מבוטל",
  "4": "ריסק זמני",
  "5": "בתביעה",
  "6": "חסום להפקדות",
  "7": "תום תקופה",
  "8": "ריסק זמני אוטומטי",
  "9": "שמירת כיסוי",
  "10": "לא רלוונטי",
};

export const SUG_TOCHNIT = {
  "1": "שכיר", "2": "עצמאי", "3": "בעל שליטה", "4": "פרט", "5": "אחר",
};

// SUG-KISUY-BITOCHI — לפי XSD מבנה אחיד 008 (זהה בביטוח/פנסיה/גמל)
export const SUG_KISUY = {
  "1":  "מוות",
  "2":  "נכות מקצועית",
  "3":  "מוות מתאונה",
  "4":  "נכות מתאונה",
  "5":  'אבדן כושר עבודה (אכ"ע)',
  "6":  "שחרור",
  "7":  "מחלות קשות",
  "8":  "תוכנית משולבת חיסכון",
  "9":  'מוות + אכ"ע (פנסיה ותיקה)',
  "10": "אחר",
};

export const MIN = { "1": "זכר", "2": "נקבה" };

export const MATZAV_MISHPACHTI = {
  "0": "לא רלוונטי", "1": "רווק/ה", "2": "נשוי/אה", "3": "גרוש/ה", "4": "אלמן/ה", "5": "לא ידוע", "6": "ידוע/ה בציבור",
};

export const KOD_ZIKA = {
  "1": "ילד/ה", "2": "בן/בת זוג", "3": "הורה",
  "4": "אח/אחות", "7": "נין/ה", "8": "לפי מינוי",
};

export const PENSIA_VATIKA = { "1": "ותיקה", "2": "חדשה" };

export const SUG_KEREN_PENSIA = {
  "1": "פנסיה מקיפה", "2": "פנסיית יסוד", "3": "פנסיית שארים",
};

export const KOD_CHISHUV_SACHAR = {
  "1": "שכר קובע",
  "2": "לפי שכר אחרון",
  "3": "ממוצע 3 שנים",
  "4": "שכר ספציפי",
  "5": "לפי תקרה",
  "6": "אחר",
  "9": "לא רלוונטי",
};

export const SUG_HAFRASHA = {
  "1":  "פיצויים",
  "2":  "תגמולים עובד",
  "3":  "תגמולים מעביד",
  "4":  "תגמולים 47",
  "5":  "אבדן כושר עבודה",
  "6":  "שונות עובד",
  "7":  "שונות מעביד",
  "8":  'קה"ש עובד',
  "9":  'קה"ש מעביד',
  "10": "תגמולים פרט",
  "11": "ריסק מוות",
  "12": "חיסכון לכל ילד",
};

// ── שדות קרן פנסיה (KisuiBKerenPensia / HeshbonOPolisa) — מבנה אחיד 008 ──────

// MEVUTACH — האם העמית מבוטח בקרן הפנסיה
export const MEVUTACH_BAKEREN = {
  "1": "כן", "2": "לא", "3": "לא רלוונטי",
};

// VITUR-KISUY-BITUCHI
export const VITUR_KISUY_BITUCHI = {
  "1": "יש", "2": "אין", "3": "לא רלוונטי (אחרי גיל פרישה)",
};

// SUG-VITOR-SHAERIM
export const SUG_VITOR_SHAERIM = {
  "0": "לא קיים", "1": "ויתור מלא", "3": "ילדים בלבד", "4": "בן זוג בלבד",
};

// NECHUT-MITPATAHAT בפנסיה (KisuiBKerenPensia): 1=יש 2=אין
// (שונה מהשדה באותו שם בביטוח — שם המשמעות היא שיעור ההתפתחות)
export const NECHUT_MITPATAHAT_PENSIA = {
  "1": "כן", "2": "לא",
};

// STATUS-MAASIK (PirteiOved, תחת PirteiTaktziv) — מבנה אחיד 008
export const STATUS_MAASIK = {
  "1": "מעסיק נוכחי",
  "2": "מעסיק קודם",
  "3": 'סה"כ מעסיקים קודמים',
};

// SUG-MAFKID — מי הפקיד (פירוט הפקדות מתחילת השנה). מבנה אחיד 008.
export const SUG_MAFKID = {
  "1": "עובד",
  "2": "מעסיק נוכחי",
  "3": "מעסיק קודם",
  "4": "ביטוח לאומי",
  "5": "הפקדת הורים",
  "6": "ניוד כספים",
};

// KOD-SUG-PEULA — סוג תנועה ב-MeshichaNiud (משיכה / ניוד / תיקון). מבנה אחיד 008.
export const KOD_SUG_PEULA = {
  "1": "משיכה",
  "2": "ניוד",
  "3": "תיקון",
};

// KOD-TECHULAT-SHICHVA — per MivneAchid Excel 008, sheet "סכימת השדות - אחזקות"
export const KOD_TECHULAT_SHICHVA = {
  "1":  "עד חוק ההסדרים (1997-2000)",
  "2":  "לאחר חוק ההסדרים (1997-2000)",
  "3":  "עד 31.12.2004",
  "4":  "עד 31.12.2005",
  "5":  "מ-01.01.2005 עד 31.12.2007",
  "6":  "מ-01.01.2006 עד 31.12.2007",
  "7":  "מ-01.01.2008",
  "8":  "עד 31.12.2002",
  "9":  "פיצויים",
  "10": "נדרש חישוב ידני",
  "11": "מ-01.01.2003 עד 31.12.2005",
  "12": "מ-01.01.2006 עד 31.12.2011",
  "13": "החל מ-01.01.2012",
  "14": "חשבון חדש",
};

// SUG-ITRA-LETKUFA — per MivneAchid Excel 008
export const SUG_ITRA_LETKUFA = {
  "1": "הון",
  "2": "קצבה משלמת",
  "3": "קצבה לא משלמת",
  "4": "נתון לבחירת הלקוח",
};

// KOD-EMTZAEI-TASHLUM — לפי XSD אחזקות חברות ביטוח 008 (NetuneiGvia)
export const KOD_EMTZAEI_TASHLUM = {
  "1": "העברה בנקאית",
  "2": "הוראת קבע",
  "3": "כרטיס אשראי",
  "4": "מזומן",
  "5": "אחר",
  "6": "המחאה",
};

// TADIRUT-TASHLUM — לפי XSD אחזקות חברות ביטוח 008 (NetuneiGvia)
export const TADIRUT_TASHLUM = {
  "1": "שנתי", "2": "חצי שנתי", "3": "רבעוני",
  "4": "חודשי", "5": "חד פעמי",
};

export const SEIF_14 = { "1": "כן", "2": "לא", "3": "לא רלוונטי" };

export const KAYEMET_HATAVA = { "1": "כן", "2": "לא" };
export const SUG_HATAVA = { "1": "הנחה באחוזים", "2": "הנחה בסכום" };

export const HUTAL_SHIABUD = { "1": "כן", "2": "לא" };
export const HUTAL_IKUL = { "1": "כן", "2": "לא" };

export const KAYAM_CHOV = { "1": "כן", "2": "לא" };
export const SUG_HOV = {
  "1": "חוב", "2": "פיגור", "3": "חוב + פיגור",
  "4": "ניכוי יתר", "5": "ניכוי יתר + פיגור",
};

export const TIKUN_190 = { "1": "כן", "2": "לא" };
export const KOLEL_ZAKAUT_AGACH = {
  "1": "כן — זכאות לאגח",
  "2": "לא",
  "3": "חלקי",
  "4": "לא רלוונטי",
};

export const SUG_KUPA = {
  "1": "קופה משלמת",
  "2": "קופה לא משלמת",
  "3": "קופת גמל להשקעה",
};

export const KOD_SUG_MASLUL = {
  "0": "לא רלוונטי",
  "1": "מסלול השקעה",
  "2": "מסלול ברירת מחדל",
};

export const STATUS_STYLE = {
  "פעיל":             { bg: "#dcfce7", color: "#166534" },
  "מוקפא / מסולק":   { bg: "#fef9c3", color: "#92400e" },
  "מבוטל":            { bg: "#fee2e2", color: "#991b1b" },
  "חסום להפקדות":     { bg: "#fef9c3", color: "#92400e" },
  "בתביעה":           { bg: "#fce7f3", color: "#9d174d" },
  "תום תקופה":        { bg: "#f1f5f9", color: "#475569" },
  default:             { bg: "#f1f5f9", color: "#475569" },
};

export const CATEGORY_STYLE = {
  "ביטוח מנהלים": { bg: "#ecfeff", border: "#06b6d4", light: "#cffafe", accent: "#0891b2", dark: "#155e75" },
  "קרן פנסיה":    { bg: "#eff6ff", border: "#2563eb", light: "#dbeafe", accent: "#2563eb", dark: "#1d4ed8" },
  "ביטוח חיים":   { bg: "#fff1f2", border: "#e11d48", light: "#ffe4e6", accent: "#e11d48", dark: "#be123c" },
  "קופת גמל":     { bg: "#fffbeb", border: "#d97706", light: "#fef3c7", accent: "#d97706", dark: "#b45309" },
  "קרן השתלמות":  { bg: "#f0fdf4", border: "#16a34a", light: "#dcfce7", accent: "#16a34a", dark: "#15803d" },
  "קופת גמל להשקעה": { bg: "#f5f3ff", border: "#7c3aed", light: "#ede9fe", accent: "#7c3aed", dark: "#6d28d9" },
  "חיסכון לכל ילד": { bg: "#fff1f2", border: "#f43f5e", light: "#ffe4e6", accent: "#f43f5e", dark: "#e11d48" },
  "פרט":    { bg: "#eef2ff", border: "#6366f1", light: "#e0e7ff", accent: "#4f46e5", dark: "#312e81" },
  "בריאות": { bg: "#fffbeb", border: "#d97706", light: "#fef3c7", accent: "#b45309", dark: "#92400e" },
  "חיים":   { bg: "#fff1f2", border: "#e11d48", light: "#ffe4e6", accent: "#e11d48", dark: "#be123c" },
  "חיסכון": { bg: "#f5f3ff", border: "#7c3aed", light: "#ede9fe", accent: "#7c3aed", dark: "#6d28d9" },
  "תיק מנוהל": { bg: "#f0f9ff", border: "#0284c7", light: "#e0f2fe", accent: "#0284c7", dark: "#0369a1" },
};

export const SUG_HATZMADA = {
  "1": "חצי שנתי", "2": "חודשי", "3": "מתואם", "4": "לא צמוד",
  "5": "רווחי הצמדה", "6": "משתתף ברווחים", "7": "דולר",
  "8": "צמוד למדד הליבור", "9": "צמוד למט\"ח לא דולרי"
};

export const OFEN_TASHLUM_SCHUM_BITUACH = {
  "1": "סכום חד פעמי", "2": "קצבה", "3": "תשלומים תקופתיים",
  "4": "אחר", "5": "הון+קצבה"
};

export const KAVOA_MISHTANE = {
  "1": "קבוע", "2": "משתנה"
};

export const MESHALEM_HAKISUY = {
  "1": "מעסיק", "2": "עובד", "3": "מעסיק עם תקרה של אחוז מהשכר",
  "4": "מעסיק והיתרה ע\"ח העובד", "5": "מעסיק והיתרה ע\"ח הפרשות",
  "6": "מתוך ההפרשות"
};

export const IND_YES_NO = {
  "1": "כן", "2": "לא", "3": "לא ידוע"
};

export const KITZBA_ZMUDA_LAMADAD = {
  "1": "24 חודשים", "2": "36 חודשים", "3": "48 חודשים",
  "4": "60 חודשים", "5": "לכל התקופה"
};

export const NACHUT_MITPATAHAT = {
  "1": "1%", "2": "2%", "3": "לא"
};

// ── שדות כיסויי חיים / ריסק (SUG_MUTZAR 5/6/7/8) — לפי XSD אחזקות חברות ביטוח 008 ──

// SUG-MEVUTACH (PirteiKisuiBeMutzar) — מי המבוטח בכיסוי
export const SUG_MEVUTACH = {
  "1": "ראשי", "2": "משני", "3": "ילד", "4": "הדדי", "5": "אחר",
};

// SUG-ISUK (PirteiKisuiBeMutzar) — הגדרת העיסוק באכ"ע
export const SUG_ISUK = {
  "1": "כל עיסוק", "2": "עיסוק סביר אחר", "3": "עיסוק ספציפי",
};

// SUG-KISUI-ETZEL-YATZRAN (ZihuiKisui)
export const SUG_KISUI_ETZEL_YATZRAN = {
  "1": "ביטוח יסודי", "2": "נספח (ריידר)",
};

// KOD-SUG-TOSEFET (PirteiTosafot) — תוספת חיתום
export const KOD_SUG_TOSEFET = {
  "1": "רפואית באחוזים",
  "2": "רפואית בפרומיל",
  "3": "מקצועית / תחביב באחוזים",
  "4": "מקצועית / תחביב בפרומיל",
  "5": "רפואית בסכום",
  "6": "מקצועית / תחביב בסכום",
};

// SUG-HANACHA-KISUY (PirteiKisuiBeMutzar)
export const SUG_HANACHA_KISUY = {
  "1": "עלות כפויה", "2": "הנחה באחוזים", "3": "הנחת סכום",
  "4": "פרומיל", "5": "אחר",
};

// SUG-MASLUL-LEBITUAH (SchumeiBituahYesodi)
export const SUG_MASLUL_LEBITUAH = {
  "0": "יסודי",
  "1": "סכום ביטוח מבוקש",
  "2": "כפולות שכר",
  "3": "אחוז הקצאה לחיסכון",
  "4": "חיסכון טהור",
};

// SUG-POLISA (HeshbonOPolisa)
export const SUG_POLISA = {
  "1": "קלאסי", "2": "עדיף", "3": "פוליסה משנת 2004 ואילך", "4": 'ריסק / אכ"ע',
};

// KISUY-ISHY-KVOZATI (HeshbonOPolisa)
export const KISUY_ISHY_KVOZATI = {
  "1": "אישי", "2": "קבוצתי", "3": "אישי + קבוצתי",
};

// SUG-HATVIAA (PirteyTvia)
export const SUG_HATVIAA = {
  "1": "קצבת זקנה",
  "2": "מות המבוטח",
  "3": 'קצבת אכ"ע / נכות (לרבות שחרור)',
  "4": "קצבת שארים",
  "5": "מקרה ביטוח אחר",
};

// KOD-STATUS-TVIAA (PirteyTvia)
export const KOD_STATUS_TVIA = {
  "1": "מאושרת",
  "2": "נדחתה",
  "3": "בבירור היצרן",
  "4": "בבירור משפטי",
  "5": "שולמה והסתיימה",
  "6": "אחר",
};

// OFEN-TASHLUM (PirteyTvia)
export const OFEN_TASHLUM_TVIA = {
  "1": "סכום חד פעמי", "2": "קצבה", "3": "לשיעורין", "4": "אחר",
};

// OFEN-HATZMADAT-GVIA (NetuneiGvia)
export const OFEN_HATZMADAT_GVIA = {
  "1": "צמוד לשכר",
  "2": "מדד המחירים לצרכן",
  "3": "מדד גבייה משוקלל",
  "4": "מדד חצי-שנתי",
  "5": "מדד חצי-שנתי מותאם",
  "6": "לא צמוד",
  "7": "צמוד לדולר",
  "8": "צמוד למדד ידוע בראשון לחודש",
  "9": "צמוד למדד אחרון ידוע",
  "10": "תוספת יוקר עם תקרה",
  "11": "תוספת יוקר בלי תקרה",
};

// SUG-TEUDA / SUG-TEUDA-MESHALEM
export const SUG_TEUDA = {
  "1": "ת.ז.", "2": "דרכון", "3": "חסוי",
};
export const SUG_TEUDA_MESHALEM = {
  "1": "ח.פ.", "2": "ח.צ.", "3": "ת.ז.", "4": "דרכון",
  "5": "תאגיד", "6": "עוסק מורשה", "7": "מספר מעסיק אצל היצרן", "8": "לא ידוע",
};

// KOD-SUG-MUTZAR-BITUACH (PerutMitryot — כיסוי קולקטיבי)
export const KOD_SUG_MUTZAR_BITUACH = {
  "1": "מוות",
  "2": "נכות מקצועית",
  "3": "מוות מתאונה",
  "4": "נכות מתאונה",
  "5": "אבדן כושר עבודה",
  "6": "מחלות קשות",
  "7": "אחר",
  "8": "שחרור",
};

// MESHALEM-DMEI-HABITUAH (PerutMitryot)
export const MESHALEM_DMEI_HABITUAH_MITRIYA = {
  "1": "בעל הפוליסה", "2": "העמית המבוטח", "3": "תשלום משותף",
};

// TADIRUT-HATSHLUM (PerutMitryot)
export const TADIRUT_HATSHLUM_MITRIYA = {
  "1": "חודשי", "2": "רבע שנתי", "3": "חצי שנתי", "4": "שנתי", "5": "חד פעמי",
};
